import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SignInActions } from 'auth/constants';
import { useAuthActions, useSignInRedirectTarget } from 'auth/hooks';
import { authSchema } from 'auth/schemas';
import { IAuthForm, IAuthUser } from 'auth/types';
// Deprecated (authOld/coreOld) - will be changed when the new unauthenticated
// homepage design is implemented
import { login } from 'authOld/utils';
import { Loader } from 'core/elements';
import { ApiStatus, NotificationPosition } from 'core/enums';
import { useNotificationContext } from 'core/states';
import { goTo } from 'coreOld/utils';

import HomeView from './HomeView';

interface IProps {
  user?: IAuthUser;
  accessPlainHomepage?: boolean;
  isPageLoading?: boolean;
}

const Home = ({ user, accessPlainHomepage = false, isPageLoading = false }: IProps) => {
  const navigate = useNavigate();
  const redirectTarget = useSignInRedirectTarget();

  const { t } = useTranslation();
  const { showNotification } = useNotificationContext();

  const { signIn } = useAuthActions();

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<IAuthForm>({
    resolver: yupResolver(authSchema()),
  });

  const onSignIn = async (data: IAuthForm) => {
    const payload = {
      ...data,
      ...{
        signinAction: SignInActions.RESOLVE_ACCOUNT_TYPE,
        redirectUrl: redirectTarget,
      },
    };

    const { success, ssoEnabled, ssoRedirectUrl } = await signIn(payload);

    if (!success) {
      return;
    }

    if (!ssoEnabled) {
      showNotification({
        title: t('titleError'),
        type: ApiStatus.ERROR,
        message: t('errorNonSsoSignIn'),
        position: NotificationPosition.TOP,
      });

      return;
    }

    if (ssoEnabled && ssoRedirectUrl) {
      goTo(ssoRedirectUrl);

      return;
    }

    await login(navigate, showNotification as any);
  };

  if (isPageLoading) {
    return <Loader fullHeight />;
  }

  return (
    <HomeView
      control={control}
      user={user}
      accessPlainHomepage={accessPlainHomepage}
      handleSubmit={handleSubmit}
      errors={errors}
      onSignIn={onSignIn}
    />
  );
};

export default Home;
